import React, { useMemo } from 'react';
import { IncidentItem } from '@/server/services/GoogleBigQuery/BigQueryIncidentsClient.types';
import { useLinkPreviewMediaData } from '@/components/pages/SituationalAwareness/hooks/useLinkPreviewMediaData';
import { useSeverityLevelsData } from '@/components/pages/SituationalAwareness/hooks/useSeverityLevelsData';
import { useUserIncidentsColorSchemes } from '@/components/pages/SituationalAwareness/hooks/useUserIncidentsColorSchemes';
import { TargetCard } from '../TargetCard';

interface TargetIncidentCardProps {
  target: Pick<
    IncidentItem,
    | 'Title'
    | 'IncidentTypeID'
    | 'IncidentTypeName'
    | 'IncidentDateTime'
    | 'SeverityLevel'
    | 'DataSource'
    | 'Photo'
    | 'Address'
    | 'Latitude'
    | 'Longitude'
    | 'IncidentDescription'
    | 'Hyperlink'
    | 'SupplyChainMapping'
    | '_targetType'
  >;
  actions?: React.ReactNode;
}

export const TargetIncidentCard: React.FC<TargetIncidentCardProps> = ({ target, actions }) => {
  const { severityNameById } = useSeverityLevelsData();
  const { data, isLoading } = useLinkPreviewMediaData({ link: target.Hyperlink, enabled: !target.Photo });
  const severityName = severityNameById.get(target.SeverityLevel);
  const { getIncidentColor } = useUserIncidentsColorSchemes();
  const incidentColor = useMemo(() => getIncidentColor(target as IncidentItem), [target, getIncidentColor]);

  return (
    <div>
      <TargetCard
        details={{
          incidentMarkerColor: incidentColor,
          dataSource: target.DataSource,
          severityName: severityName,
          incidentTypeName: target.IncidentTypeName,
          date: target.IncidentDateTime,
          addressName: target.Address,
          coords: { lat: target.Latitude, lng: target.Longitude },
        }}
        incident={target}
        isMediaLoading={isLoading}
        imageSrc={target.Photo || data?.imageSrc}
        videoSrc={data?.videoSrc}
        videoSrcType={data?.videoSrcType}
        description={target.IncidentDescription}
        link={target.Hyperlink}
      />
      {actions}
    </div>
  );
};
